<template lang="pug">
shListData(title="Inventarios Temporales" resolver="temporaryStocks" keyData="temporaryStock" component="shTemporaryStock")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'TemporaryStocks',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/temporaryStock/TemporaryStocks.vue